module.exports = __webpack_public_path__ + "static/media/BM_Dashboard_LogoBG.382c2c09.png";